import { gql } from '@apollo/client';

export const ALL_NATURE_OF_EMPLOYMENTS = gql`
  query AllNatureOfEmployments {
    natureOfEmployment: getNatureOfEmployments {
      id
      name
    }
  }
`;
